// extracted by mini-css-extract-plugin
export var attribution = "_c2-4";
export var authorName = "_c2-5";
export var quote = "_c2-3";
export var testimonial = "_c2-2";
export var trustedBy = "_c2-0";
export var trustedByLabel = "_c2-1";